import { render, staticRenderFns } from "./EditRoleRequest.vue?vue&type=template&id=3fac1db3"
import script from "./EditRoleRequest.vue?vue&type=script&lang=js"
export * from "./EditRoleRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports